import { Button, Paper, Backdrop, CircularProgress } from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ExportToCsv } from "export-to-csv";
import React, { useEffect, useState, useContext } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import EnterpriseMenu from "../EnterpriseMenu/EnterpriseMenu";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
// import DatePicker from '@mui/lab/DatePicker';
import "./Download.css";
import moment from "moment";
import { URL } from "../../constants/constant";
import FilterContext from "../../components/StateManagement/Context.js";
import { set } from "date-fns";
var axios = require("axios");

const adaniHRList = [
  "Adani_Group_Driver@adani",
  "Adani_S&M_CementBusiness_HO@adani",
  "Adani_S&M_CementBusiness_Central@adani",
  "Adani_S&M_CementBusiness_East@adani",
  "Adani_S&M_CementBusiness_West@adani",
  "Towage_Terminals@adani",
  "Ambuja_ACL_Tuticorin@adani",
  "Thondebhavi_Cement@adani",
  "ACC_limited_Mumbai@adani",
  "Kudithini_Cement@adani",
  "ACC_limited_Wadi@adani",
  "TotalGas_North@adani",
  "Ambuja_South@adani",
  "Ambuja_North@adani",
  "hr3@adani",
  "hrwin@adani",
]


const Download = () => {
  const [profileType, setProfileType] = React.useState("");
  const [profileName, setProfileName] = React.useState("");
  const [caseType, setCaseType] = React.useState("");
  const [date1, setDateRangeValue1] = React.useState(new Date());
  const [date2, setDateRangeValue2] = React.useState(new Date());
  const [downloadType, setDownloadType] = React.useState("");
  const [profileType2, setProfileType2] = React.useState("");
  const [profileName2, setProfileName2] = React.useState("");
  const [enterprises, setEnterprises] = useState([]);
  const [selectedOption, setSelectedOption] = useState();
  const [isDownloading, setIsDownloading] = useState(false);
  const { caseListFilters, updateCaseFilters } = useContext(FilterContext);

  useEffect(() => {
    var config = {
      method: "get",
      url: URL.demystify_url + "basicCaseData/fetchEnterprises/",
      headers: {},
    };
    axios(config)
      .then(function (response) {
        setEnterprises(response.data.message.All);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const handleExport = async (event) => {
    if (profileType === "" || selectedOption === "" || caseType === "") {
      alert("all fields are required in order to export");
      return;
    }

    if (downloadType === 'adaniFormat' && ((selectedOption !== 'Adani_AHC' && selectedOption !== "Adani_PEHC") || profileType !== "Corporate")) {
      alert("Adani Format is only enabled for Adani_AHC Corporate")
      return
    }

    var data = JSON.stringify({
      date_from: moment(date1).format("YYYY-MM-DD"),
      date_to: moment(date2).format("YYYY-MM-DD"),
      profile_type: profileType,
      profileName: selectedOption,
      download_type: downloadType,
      case_type: caseType,
    });

    setIsDownloading(true);

    let fetchDatasetUrl = "";
    let presignedUrlPresent = false;

    if (downloadType == "UnitRanges" ||
      downloadType == "DemystifyInitialOutput"
    ) {
      fetchDatasetUrl = URL.demystify_url + "caseDetails/fetchUnitRanges";
    } else if (downloadType == "BasicCaseData") {
      fetchDatasetUrl = URL.demystify_url + "caseDetails/fetchDataset/";
      presignedUrlPresent = true;
    } else if (
      downloadType == "standardFormat" ||
      downloadType == "standardFormatWithUnitRanges"
    ) {
      presignedUrlPresent = true;
      fetchDatasetUrl = URL.demystify_url + "caseDetails/fetchDatasetURL";
    } else if (downloadType === 'adaniFormat' && (selectedOption === 'Adani_AHC' || selectedOption === "Adani_PEHC")) {
      presignedUrlPresent = true
      fetchDatasetUrl = `${URL.demystify_url}caseDetails/fetchAdaniData`
    }

    var config = {
      method: "post",
      url: fetchDatasetUrl,
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data,
    };

    try {
      console.log(config)
      let resp = await axios(config);
      let data = resp.data["report"];
      setIsDownloading(false);
      if (!data?.length) {
        alert("No Data Present in the selected Timeframe")
        return
      }
      if (presignedUrlPresent == true) {
        // data contains a presigned Url
        window.open(data, '_blank');
      }
      else {

        let fileName =
          downloadType +
          profileName +
          "_" +
          caseType +
          "_" +
          moment(date1).format("YYYY-MM-DD") +
          "_" +
          moment(date2).format("YYYY-MM-DD");
        const options = {
          fieldSeparator: ",",
          quoteStrings: '"',
          decimalSeparator: ".",
          showLabels: true,
          showTitle: true,
          filename: fileName,
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
        };

        const csvExporter = new ExportToCsv(options);

        csvExporter.generateCsv(data);
      }
    } catch (error) {
      setIsDownloading(false);
      console.log(error);
      alert(error);
    }
  };


  const [adaniHR, setAdaniHR] = useState(undefined);
  const [adaniHRPass, setAdaniHRPass] = useState(undefined);
  const [adaniBulkSumbitCounter, setAdaniBulkSumbitCounter] = useState(0);
  const [adaniDownloadReportEndDate, setAdaniDownloadReportEndDate] = useState(new Date());
  const [adaniDownloadReportStartDate, setAdaniDownloadReportStartDate] = useState(new Date() - 7 * 24 * 60 * 60 * 1000);
  const [isAdaniJobSubmitting, setIsAdaniJobSubmitting] = useState(false);
  const [adaniCurrentJobRows, setAdaniCurrentJobRows] = useState([]);

  const handleAdaniBulkZipStart = async (event) => {
    setIsAdaniJobSubmitting(true);
    if (adaniHR && adaniDownloadReportEndDate && adaniDownloadReportStartDate) {
      const payload = JSON.stringify({
        date_from: moment(adaniDownloadReportStartDate).format("YYYY-MM-DD"),
        date_to: moment(adaniDownloadReportEndDate).format("YYYY-MM-DD"),
        //TODO: checks on the line below
        username: JSON.parse(localStorage.getItem("userDetails"))['email'].split('@')[0].replace('.', ''),
        hr_login_name: adaniHR,
        hr_login_password: adaniHRPass
      });
      const submitConfig = {
        method: "post",
        url: URL.demystify_url + "caseDetails/startAdaniReportsBulkFetch",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
        data: payload,
      };
      try {
        let resp = await axios(submitConfig);
        if (resp) {
          setIsAdaniJobSubmitting(false);
          setAdaniBulkSumbitCounter(adaniBulkSumbitCounter + 1);
        }
      } catch (error) {
        setIsAdaniJobSubmitting(false);
        console.log(error);
      }
    }
    setIsAdaniJobSubmitting(false);
  };


  useEffect(() => {
    
    const adaniStatusCheckURL = URL.demystify_url + "caseDetails/checkCurrentBulkReportStatus";
    axios.get(adaniStatusCheckURL).then((response) => {
      if (response.data) {
        const jobsStatus = response.data;
        const runningJobs = jobsStatus['currently_running_jobs'];
        const succeededJobs = jobsStatus['succeeded_jobs'];

        let finalRows = runningJobs.concat(succeededJobs);
        finalRows = finalRows.map((item) => {
          return {
            "jobname": item['name'],
            "status": item['status'],
            "startedat": item['startDate'],
            "url": item['result'] || []

          }
        })
        setAdaniCurrentJobRows(finalRows)

      }
    }).catch((error) => {
      console.log(error);
    })
  }, [adaniBulkSumbitCounter])

  const handleEnterpriseChange = (updatedEnterprise) => {
    updateCaseFilters("selectedEnterprise", updatedEnterprise);
    setSelectedOption(updatedEnterprise);
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
      <div className="outerDiv1">
        <Paper
          elevation={6}
          style={{ width: "49%", padding: "20px", borderRadius: 15 }}
        >
          <h1>Download Data Set</h1>
          <div style={{ marginTop: "-5px" }}>
            {" "}
            Choose a filter and download data{" "}
          </div>
          <div style={{ marginTop: "25px" }}>
            <div style={{ float: "left", display: "flex", alignItems: "center" }}>
              <span> Profile Type </span>
              <Box sx={{ minWidth: 150, marginLeft: "10px" }}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">
                    {" "}
                    ProfileType{" "}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={profileType}
                    label="profileType"
                    onChange={(event) => setProfileType(event.target.value)}
                  >
                    <MenuItem value={"Corporate"}>Corporate</MenuItem>
                    <MenuItem value={"dynamic-set"}>Insurance</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
            <div
              style={{ float: "right", display: "flex", alignItems: "center" }}
            >
              <span> Profile Name </span>
              <Box sx={{ minWidth: 200, marginLeft: "10px" }}>
                <FormControl fullWidth size="small">
                  <EnterpriseMenu
                    enterprises={enterprises}
                    handleEnterpriseChange={handleEnterpriseChange}
                    needAll={false}
                  />
                </FormControl>
              </Box>
            </div>
          </div>
          <div>
            <div style={{ float: "left", display: "flex", alignItems: "center" }}>
              <span style={{ marginTop: "30px" }}>
                {" "}
                Filter Database By: Date Verified{" "}
              </span>
            </div>
            <div
              style={{
                float: "right",
                display: "flex",
                alignItems: "center",
                marginTop: "20px",
              }}
            >
              <span> Case Type </span>
              <Box sx={{ minWidth: 200, marginLeft: "10px" }}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">CaseType</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={caseType}
                    label="caseType"
                    onChange={(event) => setCaseType(event.target.value)}
                  >
                    <MenuItem value={"VERIFIED"}> VERIFIED </MenuItem>
                    <MenuItem value={"INCOMPLETE"}> INCOMPLETE </MenuItem>
                    <MenuItem value={"Data Entry Pending"}>
                      {" "}
                      DATA ENTRY PENDING{" "}
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
          </div>
          <div>
            <div
              style={{
                marginTop: "30px",
                display: "flex",
                alignItems: "center",
                float: "left",
              }}
            >
              <span style={{ marginRight: "10px" }}> Date Range </span>
              <DatePicker
                selected={date1}
                onChange={(newValue) => {
                  setDateRangeValue1(newValue);
                }}
                className="datePicker1"
              />

              <span style={{ marginRight: "10px", marginLeft: "-5px" }}>
                {" "}
                to{" "}
              </span>
              <DatePicker
                selected={date2}
                onChange={(newValue) => {

                  setDateRangeValue2(newValue);
                }}
                className="datePicker2"
              />
            </div>
            <div
              style={{
                float: "right",
                display: "flex",
                alignItems: "center",
                marginTop: "15px",
              }}
            >
              <span> Download Type </span>
              <Box sx={{ minWidth: 100, marginLeft: "10px" }}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label"></InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={downloadType}
                    label=""
                    onChange={(event) => setDownloadType(event.target.value)}
                  >
                    <MenuItem value={"BasicCaseData"}> Case and User Data </MenuItem>
                    <MenuItem value={"UnitRanges"}> Path with Unit & Range </MenuItem>
                    <MenuItem value={"DemystifyInitialOutput"}> Demystify Captured Values </MenuItem>
                    <MenuItem value={"standardFormat"}>Standard Format</MenuItem>
                    <MenuItem value={"standardFormatWithUnitRanges"}>Standard Format Unit Ranges</MenuItem>
                    <MenuItem value={"adaniFormat"}>Adani Format</MenuItem>
                    <MenuItem disabled value={"MER"}>
                      {" "}
                      MER
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
          </div>
          <div>
            <Button
              style={{ marginTop: "25px", marginLeft: "30%" }}
              variant="contained"
              onClick={(e) => handleExport(e)}
            >
              {" "}
              Export Download Set{" "}
            </Button>
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={isDownloading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            {/* <Button style={{ marginTop: '25px', marginLeft: '10px' }} disabled variant='contained'>  Preview </Button> */}
          </div>
        </Paper>
        <Paper
          elevation={6}
          style={{
            width: "49%",
            marginLeft: "30px",
            borderRadius: 15,
            padding: 20,
          }}
        >
          <h1>Statistics Report</h1>
          <div style={{ marginTop: "-5px" }}>
            {" "}
            Choose a filter and download report{" "}
          </div>
          <div style={{ marginTop: "35px" }}>
            <div style={{ float: "left", display: "flex", alignItems: "center" }}>
              <span> Profile Type </span>
              <Box sx={{ minWidth: 150, marginLeft: "10px" }}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">
                    {" "}
                    ProfileType{" "}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={profileType2}
                    label="profileType"
                    onChange={(event) => setProfileType2(event.target.value)}
                  >
                    <MenuItem value={"HDFC Life - Retail"}>
                      HDFC Life - Retail
                    </MenuItem>
                    <MenuItem value={"ICICI Pru - Retail"}>
                      ICICI Pru - Retail
                    </MenuItem>
                    <MenuItem value={"ABHI - Retail"}>ABHI - Retail</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
            <div
              style={{ float: "right", display: "flex", alignItems: "center" }}
            >
              <span> Profile Name </span>
              <Box sx={{ minWidth: 200, marginLeft: "10px" }}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">
                    ProfileName
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={profileName2}
                    label="profileName"
                    onChange={(event) => setProfileName2(event.target.value)}
                  >
                    <MenuItem value={"dynamic-set"}>dynamic-set</MenuItem>
                    <MenuItem value={"dynamic-set-other"}>
                      dynamic-set-other
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
          </div>
          <div>
            <div
              style={{
                marginTop: "35px",
                display: "flex",
                alignItems: "center",
                float: "left",
              }}
            >
              <span style={{ marginRight: "10px" }}> Date Range </span>
              <DatePicker
                selected={date1}
                onChange={(newValue) => {

                  //  setDateRangeValue1(newValue);
                }}
                className="datePicker1"
              />
              <span style={{ marginRight: "10px", marginLeft: "10px" }}>
                {" "}
                to{" "}
              </span>
              <DatePicker
                selected={date2}
                onChange={(newValue) => {

                  //  setDateRangeValue1(newValue);
                }}
                className="datePicker2"
              />
            </div>
          </div>
          <div>
            <Button
              style={{ marginTop: "50px", marginLeft: "30%" }}
              variant="contained"
            >
              {" "}
              Export Statistics Report{" "}
            </Button>
          </div>
        </Paper>
      </div>
      <div className="outerDiv2">
        <Paper
          elevation={6}
          style={{ width: "49%", padding: "20px", borderRadius: 15 }}
        >
          <h1> Adani Bulk Reports </h1>
          <div>
            <FormControl fullWidth size="small">
              <TextField id="outlined-basic" label="HRWin User" variant="outlined" onChange={ (event) => setAdaniHR(event.target.value) }/>
              <TextField id="outlined-basic" label="HRWin Password" variant="outlined" onChange={ (event) => setAdaniHRPass(event.target.value) }/>
              <div style={{ marginTop: "10px", marginLeft: "20px", display: "flex", justifyContent: "start", alignItems: "center" }}>
                <DatePicker
                  selected={adaniDownloadReportStartDate}
                  onChange={(newValue) => {
                    setAdaniDownloadReportStartDate(newValue);
                  }}
                  className="datePicker1"
                />

                <span style={{ marginRight: "10px", marginLeft: "-5px" }}>
                  &nbsp;
                  to
                </span>
                <DatePicker
                  selected={adaniDownloadReportEndDate}
                  onChange={(newValue) => {

                    setAdaniDownloadReportEndDate(newValue);
                  }}
                  className="datePicker2"
                />
              </div>
            </FormControl>

            <Button
              style={{ marginTop: "25px", marginLeft: "30%" }}
              variant="contained"
              onClick={(e) => handleAdaniBulkZipStart(e)}
              disabled={isAdaniJobSubmitting || !adaniDownloadReportStartDate || !adaniDownloadReportEndDate || !adaniHR}
            >
              {" "}
              Schedule Adani Report Job{" "}
            </Button>
          </div>
        </Paper>
        <Paper
          elevation={6}
          style={{ width: "49%", padding: "20px", borderRadius: 15 }}
        >
          <h2>Adani Bulk Report Jobs</h2>
          {adaniCurrentJobRows.length ? (<div style={{ height: '300px', overflow: 'auto' }}>
            <TableContainer component={Paper}>
              <Table sx={{ width: '95%' }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="right" sx={{ width: '25%', fontWeight: 'bold' }}>Job Name</TableCell>
                    <TableCell align="right" sx={{ width: '25%', fontWeight: 'bold' }}>Status</TableCell>
                    <TableCell align="right" sx={{ width: '25%', fontWeight: 'bold' }}>Started At</TableCell>
                    <TableCell align="right" sx={{ width: '25%', fontWeight: 'bold' }}>URL</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adaniCurrentJobRows.map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell align="right">{row.jobname}</TableCell>
                      <TableCell align="right">{row.status}</TableCell>
                      <TableCell align="right">{row.startedat}</TableCell>
                      <TableCell align="right">
                        {row.url.length ? <Button onClick={() => {
                          //this is an array of urls
                          //download all 
                          for (let i = 0; i < row.url.length; i++) {
                            window.open(row.url[i], "_blank", "noopener,noreferrer");
                          }
                        }}> Download All</Button> : <></>}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          ) : <></>}
        </Paper>
      </div>

    </div>
  );
};

export default Download;
